// extracted by mini-css-extract-plugin
module.exports = {"section":"_1Rk0L3f0EWCX6HW1vw5Jia","alternateBackground":"_2eNsQpZr7YrIusBQv2gZTs"};